/* global axios */
import ApiClient from '../ApiClient';

class HistoryC2wCampaignsApi extends ApiClient {
  constructor() {
    super('history_c2w_campaigns', { accountScoped: true });
  }

  getAll({ startDate = null, endDate = null } = {}) {
    const params = {};

    if (startDate && endDate) {
      params.start_date = startDate;
      params.end_date = endDate;
    }

    return axios.get(this.url, { params });
  }
}

export default new HistoryC2wCampaignsApi();
